import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9916c1f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-item" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col--12 col-md--2" }
const _hoisted_4 = { class: "booking-number" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "route" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = {
  key: 0,
  class: "col--auto checkin-available"
}
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col-md--12" }
const _hoisted_12 = { class: "col-md--12" }
const _hoisted_13 = { class: "list-item__content" }
const _hoisted_14 = { class: "booking-number" }
const _hoisted_15 = { class: "details" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "text" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "label" }
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "sections" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "row departure" }
const _hoisted_29 = { class: "col--12 col-md--6 flex" }
const _hoisted_30 = { class: "direction" }
const _hoisted_31 = { class: "date" }
const _hoisted_32 = { class: "label" }
const _hoisted_33 = { class: "text" }
const _hoisted_34 = { class: "route" }
const _hoisted_35 = { class: "label" }
const _hoisted_36 = { class: "text" }
const _hoisted_37 = { class: "col--12 col-md--6 flex" }
const _hoisted_38 = { class: "duration" }
const _hoisted_39 = { class: "label" }
const _hoisted_40 = { class: "text" }
const _hoisted_41 = { class: "departs" }
const _hoisted_42 = { class: "label" }
const _hoisted_43 = { class: "text" }
const _hoisted_44 = { class: "arrives" }
const _hoisted_45 = { class: "label" }
const _hoisted_46 = { class: "text" }
const _hoisted_47 = {
  key: 0,
  class: "text"
}
const _hoisted_48 = {
  key: 1,
  class: "text"
}
const _hoisted_49 = { class: "text" }
const _hoisted_50 = {
  key: 0,
  class: "price"
}
const _hoisted_51 = { class: "text" }
const _hoisted_52 = { class: "text" }
const _hoisted_53 = { class: "price bold" }
const _hoisted_54 = {
  key: 0,
  class: "section"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Extras")
], -1))
const _hoisted_56 = { class: "price bold" }
const _hoisted_57 = { class: "section" }
const _hoisted_58 = { class: "price--total price" }
const _hoisted_59 = { class: "button-container row" }
const _hoisted_60 = { class: "button-container__left col--12 col-md--6" }
const _hoisted_61 = { class: "button" }
const _hoisted_62 = { class: "button" }
const _hoisted_63 = {
  key: 0,
  class: "button"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Checkin Online", -1))
const _hoisted_65 = { class: "button-container__right col--12 col-md--6" }
const _hoisted_66 = {
  key: 0,
  class: "alert-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseExpansion = _resolveComponent("BaseExpansion")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["list-item__header", {'expanded': _ctx.expanded }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expand()))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.booking.bookingNumber), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booking.bookingSections, (section, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col--12 col-md--4",
            key: index
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_BaseSvg, {
                icon: section.icon
              }, null, 8, ["icon"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(section.routeText), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.EEEddMMMYYYY(section.departureDate)) + " " + _toDisplayString(_ctx.HHmm(section.departureDate)) + "-" + _toDisplayString(_ctx.HHmm(section.arrivalDate)), 1)
              ])
            ])
          ]))
        }), 128)),
        (_ctx.booking.checkInUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_BaseSvg, { icon: 'account/checkin' })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isAgent === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, " Customer: " + _toDisplayString(_ctx.booking.customerName), 1),
            _createElementVNode("div", _hoisted_12, " Email: " + _toDisplayString(_ctx.booking.customerEmail), 1)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_BaseExpansion, { expanded: _ctx.expanded }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("account.bookings.bookingNumber")) + ": " + _toDisplayString(_ctx.booking.bookingNumber), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("bookingType.title")), 1),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.booking.modeOfTravel), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("serviceType.title")), 1),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.booking.serviceType), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("basket.passengers")) + ":", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booking.names, (passenger, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "text",
                    key: index
                  }, _toDisplayString(passenger), 1))
                }), 128))
              ]),
              (_ctx.booking.campaignName?.length ?? 0 > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("basket.campaign")) + ":", 1),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.booking.campaignName), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booking.bookingSections, (section, index) => {
              return (_openBlock(), _createElementBlock("ul", {
                key: index,
                class: "section"
              }, [
                _createElementVNode("li", _hoisted_25, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_26, _toDisplayString(_ctx.$t("departure.outward")), 1))
                    : (_openBlock(), _createElementBlock("h4", _hoisted_27, _toDisplayString(_ctx.$t("departure.return")), 1)),
                  (section.OpenForDeparture === true)
                    ? (_openBlock(), _createBlock(_component_BaseButton, {
                        key: 2,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirect()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Checkin Online ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("li", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      (index === 0)
                        ? (_openBlock(), _createBlock(_component_BaseSvg, {
                            key: 0,
                            icon: 'arrow/arrow-right'
                          }))
                        : (_openBlock(), _createBlock(_component_BaseSvg, {
                            key: 1,
                            icon: 'arrow/arrow-left'
                          }))
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("account.bookings.date")), 1),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.EEEddMMMYYYY(section.departureDate )), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("account.bookings.route")), 1),
                      _createElementVNode("span", _hoisted_36, _toDisplayString(section.routeText), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("account.bookings.duration")), 1),
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.getDurationInMinutes(section.departureDate, section.arrivalDate)) + "min ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("account.bookings.departs")), 1),
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.EEEddMMMYYYY(section.departureDate)) + " " + _toDisplayString(_ctx.HHmm(section.departureDate)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("account.bookings.arrives")), 1),
                      _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.EEEddMMMYYYY(section.arrivalDate)) + " " + _toDisplayString(_ctx.HHmm(section.arrivalDate)), 1)
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "price",
                    key: index
                  }, [
                    (item.code === 'PAX')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(item.text) + " " + _toDisplayString(item.amount), 1))
                      : _createCommentVNode("", true),
                    (item.code !== 'PAX')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.$t(`basket.resources.description.${item.code}`)) + " " + _toDisplayString(item.code != "AMND" ? item.amount : ""), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.booking.currency) + " " + _toDisplayString((item.price+section.discount??0).toFixed(2)), 1)
                  ]))
                }), 128)),
                (section.discount > 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_50, [
                      _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t(`basket.discount`)), 1),
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.booking.currency) + " " + _toDisplayString(-section.discount.toFixed(2)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", _hoisted_53, [
                  _createElementVNode("span", null, _toDisplayString(index === 0 ? _ctx.$t(`basket.Outward.price`) : _ctx.$t(`basket.Return.price`)), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.booking.currency) + " " + _toDisplayString((section.price+section.discount??0).toFixed(2)), 1)
                ])
              ]))
            }), 128)),
            (_ctx.booking.extras.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_54, [
                  _hoisted_55,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booking.extras, (extra, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "price",
                      key: index
                    }, [
                      _createElementVNode("span", null, _toDisplayString(extra.text) + " " + _toDisplayString(extra.amount), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.booking.currency) + " " + _toDisplayString(extra.price.toFixed(2)), 1)
                    ]))
                  }), 128)),
                  _createElementVNode("li", _hoisted_56, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`basket.Extras.price`)), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.booking.currency) + " " + _toDisplayString(_ctx.booking.extras.map(e => e.price ?? 0).reduce((sum, current) => sum+current, 0).toFixed(2)), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_57, [
              _createElementVNode("li", _hoisted_58, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("account.bookings.total")) + ": " + _toDisplayString(_ctx.booking.currency) + " " + _toDisplayString((_ctx.booking.bookingSections.map(e => (e.price ?? 0) + (e.discount ?? 0)).reduce((sum, current) => sum+current, 0)).toFixed(2)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_BaseButton, {
                  disabled: !_ctx.booking.isEditable,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateBooking()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseSvg, { icon: 'account/edit' }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("account.bookings.update")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_BaseButton, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resendConfirmation())),
                  class: _normalizeClass('button--white'),
                  loading: _ctx.loading,
                  disabled: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("account.bookings.resendConfirmation")), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              (_ctx.booking.checkInUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createVNode(_component_BaseButton, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToCheckin(_ctx.booking.checkInUrl))),
                      class: "button--white"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_BaseSvg, { icon: 'account/checkin' }),
                        _hoisted_64
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_65, [
              false
                ? (_openBlock(), _createBlock(_component_BaseButton, {
                    key: 0,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.prepareCancellation(_ctx.AmendmentOptionTypeEnum.CancelBooking))),
                    class: _normalizeClass('button--danger'),
                    loading: _ctx.loadingCancel,
                    disabled: _ctx.loadingCancel
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseSvg, { icon: 'account/delete' }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("account.bookings.cancel.title")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.booking.isEditable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _createVNode(_component_BaseAlert, {
                  type: "info",
                  message: _ctx.$t('messages.myAccount.bookings.amendment.notEditable')
                }, null, 8, ["message"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["expanded"])
  ]))
}